module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-rule@2x-296db0692f92734b31011b5906eeddb2.png";